<template>
  <div>
    <OButton
      v-if="isMobile"
      class="u-center border rounded-3xl border-[#E2E5ED] text-sm font-medium text-primary-200 py-2 px-4 mr-2"
      pure
      @click="handlePageUp"
    >
      <OIcon icon="article/comments" class="mr-1"></OIcon>
      <span class="whitespace-nowrap">{{ $t('article-comment.you-comment') }}</span>
    </OButton>
    <div v-else class="mt-2 relative" @click="handlePageUp">
      <OIcon
        icon="article/comments"
        class="w-11 h-11 p-2 rounded-full u-center bg-white cursor-pointer overflow-hidden border border-[#E2E5ED]"
        aria-label="yorumlara git"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';
import { OButton, OIcon } from '~/modules/common/components/ui';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';
export default defineComponent({
  props: {
    article: {
      type: Object,
      require: true,
    },
  },
  components: { OButton, OIcon },
  setup(props) {
    const { isMobile } = useDevice();
    const { sendDetayInteractionEvent } = onedioEvents();

    const handlePageUp = () => {
      sendDetayInteractionEvent('Detay Sayfası', 'Click', 'Yoruma Git');
      const target = document.getElementById('reactions-' + props.article.legacyId);
      window.scrollTo({ top: target?.getBoundingClientRect().top + window.pageYOffset - 100, behavior: 'smooth' });
    };
    return { handlePageUp, isMobile };
  },
});
</script>
